import script from "./BillSvg.vue?vue&type=script&setup=true&lang=js"
export * from "./BillSvg.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__